/* Keep quantity-option thumbnails in sync with the picker selection. */
(() => {
  const selector = 'variant-selects[data-quantity-breaks-picker-displayed-images="variant_images"]';
  const watched = new WeakSet();

  function imageFor(variants, selected, optionIndex, value, swatchIndexes) {
    const wanted = selected.slice();
    wanted[optionIndex] = value;
    const image = variant => variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
    const exact = variants.find(variant => wanted.every((v, i) => v != null && variant.options[i] === v));
    if (image(exact)) return image(exact);
    // A size may lack its own photo. Only fall back within the selected swatch(s).
    if (!swatchIndexes.length || swatchIndexes.includes(optionIndex)) return null;
    const sameSwatches = variant => swatchIndexes.every(i => wanted[i] != null && variant.options[i] === wanted[i]);
    const fallback = variants.find(variant => sameSwatches(variant) && variant.options[optionIndex] === value && image(variant))
      || variants.find(variant => sameSwatches(variant) && image(variant));
    return image(fallback) || null;
  }

  function sync(picker) {
    let variants;
    try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); }
    catch { return; }
    if (!Array.isArray(variants)) return;
    const groups = Array.from(picker.children).filter(el => el.classList.contains('product-form__input'));
    const selected = groups.map(group => (group.querySelector('input[type="radio"]:checked') || group.querySelector('select'))?.value);
    const swatches = groups.flatMap((group, index) => group.classList.contains('product-form__input--swatches') ? [index] : []);
    groups.forEach((group, index) => {
      if (!group.classList.contains('product-form__input--quantity-breaks')) return;
      const inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
      group.querySelectorAll('label.quantity-break').forEach(label => {
        const input = inputs.find(input => input.id === label.htmlFor);
        if (!input) return;
        const src = imageFor(variants, selected, index, input.value, swatches);
        let wrapper = label.querySelector('.quantity-break__image');
        if (!src) {
          if (wrapper && !wrapper.hidden) wrapper.hidden = true;
          return;
        }
        if (!wrapper) {
          const container = label.querySelector('.quantity-break__image-and-content');
          if (!container) return;
          wrapper = document.createElement('div');
          wrapper.className = 'quantity-break__image';
          const img = document.createElement('img');
          img.loading = 'lazy';
          wrapper.append(img);
          container.prepend(wrapper);
        }
        const img = wrapper.querySelector('img');
        if (!img) return;
        if (wrapper.hidden) wrapper.hidden = false;
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        // A stale responsive source must not override the new thumbnail.
        if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
        const alt = selected.map((v, i) => i === index ? input.value : v).filter(Boolean).join(' / ');
        if (img.alt !== alt) img.alt = alt;
      });
    });
  }

  function attach(picker) {
    if (watched.has(picker)) return;
    watched.add(picker);
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        if (picker.isConnected && picker.matches(selector)) sync(picker);
      });
    };
    picker.addEventListener('change', schedule);
    // Also handle theme-editor re-renders and asynchronous native image updates.
    new MutationObserver(schedule).observe(picker, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'checked'] });
    schedule();
  }
  function scan(root) {
    if (root.matches?.(selector)) attach(root);
    root.querySelectorAll?.(selector).forEach(attach);
  }
  function start() {
    scan(document);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) scan(node);
    }))).observe(document.documentElement, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
